import fr from 'facet-rest';
import PropTypes from 'prop-types';
import React from 'react';
import {
  FDBodyText, FDStack,
} from '@facet-wealth/design';
import {
  OwnAndOweChecklistItem,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingAssetsAndLiabilitiesAdd/OnboardingAssetsAndLiabilitiesAddContent/OwnAndOweChecklistItem';

const OwnAndOweChecklistItemGroup = ({ checklistItemGroupResource }) => {
  return (
    <FDStack direction="column" width="100%">
      <FDBodyText value={checklistItemGroupResource.attr('title')} color={'textSecondary'} />
      <FDStack direction="row" spacing={4} width="100%">
        <FDStack direction="column" flexGrow={1}>
          {checklistItemGroupResource.attr('checklistItems').resources().list()
            .map((item) => (
              <OwnAndOweChecklistItem key={item.id()} checklistItemResource={item} />
            ))}
        </FDStack>
      </FDStack>
    </FDStack>
  );
};

OwnAndOweChecklistItemGroup.defaultProps = {};

OwnAndOweChecklistItemGroup.propTypes = {
  checklistItemGroupResource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export { OwnAndOweChecklistItemGroup };
